export default __webpack_public_path__ + "static/icon-18-6-91fe8636336bff8342cd9becb19add75.png";